import React from 'react';
import { connect } from 'react-redux';
import isEqual from 'fast-deep-equal';
import { Attributes } from '@leverege/ui-attributes';
import I18N from '@leverege/i18n';
import Groupings from "../../groupings/Groupings.js";
import RequestUtil from "./RequestUtil.js";
import GroupingsUtil from "./GroupingsUtil.js";
const {
  tf
} = I18N.ns('molten.imagine.groupings.ImagineGroupingFilterInstaller');
class ImagineGroupingFilterInstaller extends React.Component {
  componentDidUpdate(prevProps, prevState) {
    const {
      dispatch,
      sectionsState,
      relationship,
      currentGrouping,
      onFilterChange,
      filter
    } = this.props;

    // ItemInfo Screen
    if (onFilterChange == null) {
      // We are in an ItemInfoScreen. Get attributeName for sections
      const {
        objectType,
        item
      } = this.props;
      const nValues = {};
      let changed = false;
      currentGrouping?.sections?.forEach(s => {
        const v = Attributes.get(s.attributeName, objectType, item);
        if (v && sectionsState[s.id] !== v) {
          nValues[s.id] = v;
          changed = true;
        } else if (sectionsState[s.id] !== undefined) {
          nValues[s.id] = sectionsState[s.id];
        }
      });
      if (changed) {
        dispatch(Groupings.setSelectedSectionValues(nValues));
      }
      return;
    }
    const {
      sectionsState: pSectionsState,
      filter: pFilter,
      relationship: pRelationship
    } = prevProps;
    const newPath = relationship?.path !== pRelationship?.path;
    if (newPath || sectionsState && !isEqual(pSectionsState, sectionsState)) {
      this.installFilter();
    } else {
      const selected = filter?.metadata;
      const pSelected = pFilter?.metadata;
      if (selected && !Groupings.areSelectionsEqual(selected, pSelected) || !Groupings.areSelectionsEqual(selected, sectionsState)) {
        dispatch(Groupings.setSelectedSectionValues(selected || {}));
      }
    }
  }
  installFilter(isOnMount = false) {
    const {
      sectionsState,
      relationship,
      currentGrouping,
      onFilterChange,
      filterName
    } = this.props;
    return GroupingsUtil.installFilter({
      sectionsState,
      relationship,
      currentGrouping,
      onFilterChange,
      filterName,
      isOnMount
    });
  }
  render() {
    return null;
  }
}
const ConnectedInstaller = connect((state, props) => {
  // Do some calculation/data retrieval as necessary
  const {
    grouping,
    objRef
  } = Groupings.getGroupingAndObjRef(state);
  return {
    sectionsState: Groupings.getSelectedSectionValues(state) || {},
    currentGrouping: grouping,
    objRef
  };
})(ImagineGroupingFilterInstaller);
ConnectedInstaller.createPlugin = () => {
  return {
    id: 'molten.grouping.ImagineGroupingFilterInstaller',
    name: tf('name'),
    type: RequestUtil.FILTER_NAME,
    // Important. Used to remove filter in agg request
    location: 'hidden',
    matches: {
      type: ['GroupDataViewer', 'ItemInfoDataViewer']
    },
    component: ConnectedInstaller
  };
};
export default ConnectedInstaller;